// extracted by mini-css-extract-plugin
export default {"bootstrapTable":"Management_bootstrapTable__mkRxd","image":"Management_image__qD0CZ","promoAlert":"Management_promoAlert__LKuMN","showAlert":"Management_showAlert__F9CEX"};